import { Box, Button, Container, Grid2, Paper, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useState } from "react";
import LoadingIndicator from "../common/loading.indicator";
import { schoolApi } from "../school/school.queries";
import CoursesStep from './steps/courses.step';
import SchoolStep from './steps/school.step';
import StudentsStep from './steps/students.step';
import SubjectsStep from './steps/subjects.step';
import { userApi } from "./user.queries";

export default function UserWizardView(props) {
	const useGet = userApi.useGet('me');
	const user = useGet?.data;

	const useGetAll = schoolApi.useGetAll();
	let schools = useGetAll?.data;

	const [step, setStep] = useState(null);

	const previousStep = () => {
		setStep(step - 1);
	}

	const nextStep = () => {
		setStep(step + 1);
	}

	if (useGet?.isPending || useGetAll?.isPending) {
		return <LoadingIndicator />;
	}

	if (!schools?.length) {
		window.location.href = '/wizard';
		return;
	}

	const school = schools?.[0] || null;

	const paperSx = { p: 4, pt: 0, textAlign: 'center' };
	const stepLabels = ['School', 'Students', 'Subjects', 'Courses'];

	return (
		<Container>
			<Stack direction="column" alignItems="center" sx={{ p: 4, m: 4 }}>
				{step === null &&
					<Paper sx={{ p: 4, pt: 0 }}>
						<Grid2 container spacing={4}>
							<Grid2 size={{ xs: 12, sm: 7, md: 8 }}>
								<Typography variant="h2">Welcome!</Typography>
								<Typography variant="h5">
									Thank you so much for allowing Alara Learning to join you on your homeschool journey.
									Let's take a few moments to get you set up so you can get back to what you do best - teach!
								</Typography>
								<Button variant="contained" color="primary" sx={{ mt: 4 }} onClick={() => setStep(0)}>Get Started</Button>
							</Grid2>
							<Grid2 size={{ xs: 12, sm: 5, md: 4 }}>
								<Box sx={{ pt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
									<img src="/images/school.png" width="100%" />
								</Box>
							</Grid2>
						</Grid2>
					</Paper >
				}

				<Stack direction="column" alignItems="stretch" spacing={6} sx={{ p: 4, maxWidth: 600 }}>
					{step != null && step >= 0 &&
						<Stepper activeStep={step} alternativeLabel>
							{stepLabels.map(stepLabel => (
								<Step key={stepLabel}>
									<StepLabel>{stepLabel}</StepLabel>
								</Step>
							))}
						</Stepper>
					}

					{step == 0 && <SchoolStep sx={paperSx} school={school} onNext={nextStep} onPrevious={previousStep} />}
					{step == 1 && <StudentsStep sx={paperSx} students={schools?.[0]?.students} onNext={nextStep} onPrevious={previousStep} />}
					{step == 2 && <SubjectsStep sx={paperSx} onNext={nextStep} onPrevious={previousStep} />}
					{step == 3 && <CoursesStep sx={paperSx} onNext={nextStep} onPrevious={previousStep} />}
				</Stack>
			</Stack>
		</Container>
	);
}